import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useCenterUsers(page = 1, limit = 10) {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const centerUsersQuery = useQuery({
        queryKey: ['centerUsers', page, limit],
        queryFn: () =>
            request.get('/center/getCenterUsers', { params: { page, limit } }).then((res) => res.data),
    });

    const addCenterUserMutation = useMutation({
        mutationFn: (data) => request.post('/center/addCenterUser', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['centerUsers'], exact: false });
        },
    });

    const deleteCenterUserMutation = useMutation({
        mutationFn: (id) => request.delete('/center/deleteCenterUser', { data: { id } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['centerUsers'], exact: false });
        },
    });

    const toggleStatusMutation = useMutation({
        mutationFn: (id) => request.put('/center/toggleStatus', { id }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['centerUsers'], exact: false });
        },
    });

    const updateProfileMutation = useMutation({
        mutationFn: (data) => request.put('/center/updateProfile', data),
    });

    const getCenterProfile = () => request.get('/center/profile').then((res) => res.data);

    return {
        centerUsers: centerUsersQuery?.data?.users || [],
        isCenterUsersLoading: centerUsersQuery.isLoading,
        totalCenterUsers: centerUsersQuery?.data?.total || 0,

        addCenterUser: addCenterUserMutation.mutateAsync,
        isAddingCenterUser: addCenterUserMutation.isPending,

        deleteCenterUser: deleteCenterUserMutation.mutateAsync,
        isDeletingCenterUser: deleteCenterUserMutation.isPending,

        toggleCenterUserStatus: toggleStatusMutation.mutateAsync,
        isTogglingStatus: toggleStatusMutation.isPending,

        updateProfile: updateProfileMutation.mutateAsync,
        isUpdatingProfile: updateProfileMutation.isPending,

        getCenterProfile,
    };
}
